import { useMaApiFollowing } from '@/hooks/Intel'
import { useThreatProfileFollowing, useSelectedThreatProfileQuery } from '@/hooks/ThreatProfiles'

export const useFollowing = (options = {}) => {
  const useThreatProfile = options.useThreatProfile ?? false
  const { data: profile, isLoading: profileIsLoading } = useSelectedThreatProfileQuery()
  const maApiResult = useMaApiFollowing()
  const profileResult = useThreatProfileFollowing(profile?.name)

  if (!useThreatProfile) {
    return maApiResult
  }

  if (profileIsLoading) {
    return { isLoading: true }
  }

  return profile ? profileResult : maApiResult
}
